// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_45ddb025"};